import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Scissors, Sparkles, Droplets, Star, UserCheck, CheckCircle2 } from 'lucide-react';
function getWhatsAppLink(service: string) {
  const message = encodeURIComponent(`Hola, vengo desde la web y quiero reservar una cita para ${service}`);
  return `https://wa.me/573054520211?text=${message}`;
}
const services = [{
  id: 1,
  title: 'Corte Clásico',
  price: '$30.000 COP',
  description: 'Corte tradicional con acabado perfecto',
  icon: <Scissors className="w-6 h-6 text-brand-gold" data-id="element-124" />
}, {
  id: 2,
  title: 'Corte + Barba',
  price: '$45.000 COP',
  description: 'Combo completo para un look impecable',
  icon: <Star className="w-6 h-6 text-brand-gold" data-id="element-125" />
}, {
  id: 3,
  title: 'Perfilado de Barba',
  price: '$25.000 COP',
  description: 'Define tu estilo con precisión',
  icon: <UserCheck className="w-6 h-6 text-brand-gold" data-id="element-126" />
}, {
  id: 4,
  title: 'Corte Premium',
  price: '$50.000 COP',
  description: 'Incluye lavado, corte y styling',
  icon: <Sparkles className="w-6 h-6 text-brand-gold" data-id="element-127" />
}, {
  id: 5,
  title: 'Cejas',
  price: '$10.000 COP',
  description: 'Perfilado profesional de cejas',
  icon: <CheckCircle2 className="w-6 h-6 text-brand-gold" data-id="element-128" />
}, {
  id: 6,
  title: 'Afeitado Clásico',
  price: '$35.000 COP',
  description: 'Afeitado con navaja y toalla caliente',
  icon: <Droplets className="w-6 h-6 text-brand-gold" data-id="element-129" />
}];
export function ServicesSection() {
  return <section id="servicios" className="py-12 md:py-24 bg-brand-black relative" data-id="element-130">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="text-center mb-8 md:mb-16" data-id="element-132">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-playfair text-white mb-4 relative inline-block" data-id="element-133">
            Nuestros Servicios
            <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-brand-gold rounded-full" data-id="element-134"></div>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-brand-gray mt-6 text-lg" data-id="element-135">
            Experiencia premium para el hombre moderno
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 lg:gap-8" data-id="element-136">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          scale: 1.02
        }} className="bg-brand-card rounded-sm p-4 md:p-6 border border-brand-dark hover:border-brand-gold/50 hover:shadow-gold-glow transition-all duration-300 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 md:gap-6" data-id="element-137">
              <div className="flex items-start gap-4 flex-1" data-id="element-138">
                <div className="bg-brand-black p-3 rounded-full border border-brand-gold/20" data-id="element-139">
                  {service.icon}
                </div>
                <div data-id="element-140">
                  <h3 className="text-xl font-playfair text-white mb-1" data-id="element-141">
                    {service.title}
                  </h3>
                  <p className="text-brand-gray text-sm mb-2" data-id="element-142">
                    {service.description}
                  </p>
                  <div className="text-brand-gold font-bold text-lg" data-id="element-143">
                    {service.price}
                  </div>
                </div>
              </div>

              <a href={getWhatsAppLink(service.title)} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto text-center btn-outline-gold px-6 py-2 whitespace-nowrap" data-id="element-144">
                Reservar ahora
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}